import { firestoreDatabase } from "../firebase";

export const logEvent = (event: string): void => {
  try {
    firestoreDatabase.analytics().logEvent(event);
  } catch (error) {
    console.error("Failed to log analytic event");
  }
};
